// Breadcrumbs.tsx
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import styles from './breadcrumbs.module.css'

const Breadcrumbs: React.FC = () => {
	const location = useLocation()
	const pathnames = location.pathname.split('/').filter((x) => x)

	const breadcrumbNameMap: { [key: string]: string } = {
		library: 'Library',
		persons: 'Persons',
		person: 'Person',
		teams: 'Teams',
		matches: 'Matches',
		match: 'Match',
	}

	// Do not show breadcrumbs on the home location
	if (pathnames.length === 0) {
		return null
	}

	return (
		<nav className={styles.breadcrumbs}>
			<ul>
				<li>
					<Link to='/'>Main page</Link>
				</li>
				{pathnames.slice(0, -1).map((value, index) => {
					const to = `/${pathnames.slice(0, index + 1).join('/')}`

					return (
						<li key={to}>
							<Link to={to}>{breadcrumbNameMap[value] || value}</Link>
						</li>
					)
				})}
			</ul>
		</nav>
	)
}

export default Breadcrumbs
